<template>
  <div class="w-100">
    <WCSpinner v-if="loading" size="xl" position="center" />
    <div class="container-fluid h-100" v-else>
      <WCLoyalty
        class="my-3"
        v-for="loyalty in loyaltyBalances"
        :key="loyalty.id"
        :loyalty="loyalty"
      />

      <div class="my-3" v-if="discount">
        <div class="mobile-rewards__section row">
          <span class="ml-3 mobile-rewards__section-text">{{ $t('yourCustomerDiscounts') }}</span>
        </div>
        <div class="row">
          <p class="ml-3 pt-2 mobile-rewards__text">{{ discount }}</p>
        </div>
      </div>

      <div class="my-3" v-if="coupons">
        <div class="mobile-rewards__section row">
          <span class="ml-3 mobile-rewards__section-text">{{ $t('yourCoupons') }}</span>
        </div>
        <div class="row">
          <template v-if="coupons && coupons.length">
            <WCCoupon
              class="pl-3 pt-2"
              v-for="coupon in coupons"
              :key="coupon.id"
              :coupon="coupon"
            />
          </template>
          <p v-else class="mobile-rewards__text">{{ $t('noCoupons') }}</p>
        </div>
      </div>

      <div class="my-3" v-if="punchCards">
        <div class="mobile-rewards__section row">
          <span class="ml-3 mobile-rewards__section-text">{{ $t('yourPunchCards') }}</span>
        </div>
        <div class="row">
          <WCPunchCard class="pl-3" v-for="card in punchCards" :key="card.ruleId" :card="card" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import WCPunchCard from '@/views/Rewards/components/WCPunchCard/WCPunchCard.vue';
import WCLoyalty from '@/views/Rewards/components/WCLoyalty/WCLoyalty.vue';
import WCCoupon from '@/views/Rewards/components/WCCoupon/WCCoupon.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';

export default {
  name: 'Rewards',
  components: { WCPunchCard, WCLoyalty, WCCoupon, WCSpinner },
  data() {
    return {
      loading: false,
      punchCards: [],
      coupons: [],
      discount: '',
      loyaltyBalances: [],
    };
  },
  async created() {
    this.loading = true;
    try {
      const response = await axios.get(`/api/me/rewards`);

      this.punchCards = response.data.punchCards;
      this.coupons = response.data.coupons;
      this.discount = response.data.discount;
      this.loyaltyBalances = response.data.loyaltyBalances;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.mobile-rewards__section {
  padding-top: $pad-2;
  padding-bottom: $pad-2;
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
  &-text {
    font-weight: 700;
    font-size: $font-size-lg;
    color: var(--secondary-contrast, get-color-contrast('secondary'));
  }
}

.mobile-rewards__text {
  font-weight: 700;
  font-size: $font-size-base;
}

::v-deep .wc-coupon__expiration {
  font-size: $font-size-xs;
}
::v-deep .wc-loyalty__balance-text {
  font-size: $font-size-base;
}
::v-deep .wc-loyalty__name {
  padding-top: $pad-2;
  padding-bottom: $pad-2;
  padding-left: $container-gutter;
  margin-right: -$container-gutter;
  margin-left: -$container-gutter;
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
  color: var(--secondary-contrast, get-color-contrast('secondary'));
  font-weight: 700;
}
::v-deep .wc-punch-card__icon {
  font-size: $font-size-2xl;
  margin-right: $container-gutter;
  color: var(--primary, $primary);
}
</style>
